export enum AssetStatus {
    Active = 1,
    Deprecated = 2
}
